import axios from 'axios';
import qs from 'qs';
import { API } from '@config/common';

export const getRefreshToken = (payload) => {
  return axios({
    method: 'post',
    url: API.TOKEN_REFRESH,
    data: qs.stringify(payload),
    headers: {
      Authorization: 'Basic YXBwbGljYXRpb246c2VjcmV0',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

export const getLogin = (payload) => {
  return axios({
    method: 'post',
    url: API.LOGIN,
    headers: {
      authorization: 'Basic YXBwbGljYXRpb246c2VjcmV0',
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: qs.stringify(payload),
  });
};

export const logout = () => {
  return axios({
    method: 'post',
    url: API.LOGOUT,
    headers: { authorization: sessionStorage.accessToken },
  });
};

export const fetchSignUp = (userInfo) => {
  return axios({
    method: 'post',
    url: API.USER_SIGNUP,
    headers: { 'content-type': 'application/json' },
    data: JSON.stringify({
      email: userInfo.email,
      name: userInfo.name,
      password: userInfo.password,
      telno: userInfo.telno,
      shop_name: userInfo.shop_name,
      birth: userInfo.birth,
      gender: userInfo.gender,
      franchise_code: userInfo.franchise_code,
      lang: userInfo.lang,
      device_cnt: userInfo.device_cnt,
      email_url: `${window.location.protocol}//${window.location.host}`,
    }),
  });
};

export const findId = (payload) => {
  return axios({
    method: 'post',
    url: API.FIND_ID,
    headers: { 'content-type': 'application/json' },
    data: JSON.stringify(payload),
  });
};

export const findPassword = (payload) => {
  return axios({
    method: 'post',
    url: API.FIND_PW,
    headers: { 'content-type': 'application/json' },
    data: JSON.stringify(payload),
  });
};

export const getServiceSettings = () => {
  return axios({
    method: 'get',
    url: API.SERVICE,
    headers: { authorization: sessionStorage.getItem('accessToken') },
  });
};

export const fetchPolicy = (targetCode, policyCode) => {
  return axios({
    method: 'get',
    url: `${API.POLICY}${targetCode}/${policyCode}`,
    params: { target: targetCode, policy: policyCode },
  });
};
